<div *ngIf="parentOrganizationData?.name" class="card shadow-sm rounded-4 border-0 mb-3" style="background: #f8fafc;">
  <div class="card-body py-3 px-4">
    <h6 class="mb-0 text-primary" style="font-size: 1rem; color:#296fab !important;font-weight: 600;">
      Parent Organization: {{ parentOrganizationData.name }}
    </h6>
  </div>
</div>

<div class="edit-sub-organization-outer-container">
  <div class="edit-sub-organization-container">
    <div class="card shadow-sm rounded-4 border-0">
      <div class="card-body p-4">
        <form
          *ngIf="!isLoading"
          [formGroup]="editForm"
          (ngSubmit)="onSubmit()"
          style="max-width: 940px;"
          class="p-3 rounded bg-white shadow-sm edit-sub-organization-form"
        >
          <div class="mb-2">
            <label for="name" class="form-label">
              Sub-Organization Name <span class="text-danger">*</span>
            </label>
            <input
              id="name"
              class="form-control"
              [ngClass]="{'is-invalid': editForm.get('name')?.invalid && editForm.get('name')?.touched}"
              formControlName="name"
              placeholder="Sub-Organization Name"
              (blur)="editForm.get('name')?.markAsTouched()"
            />
            <div class="text-danger mt-1" *ngIf="editForm.get('name')?.invalid && editForm.get('name')?.touched">
              Sub-organization name is required.
            </div>
          
          <div class="mb-2">
            <label for="address1" class="form-label">Address Line 1</label>
            <input
              id="address1"
              class="form-control"
              formControlName="address1"
              placeholder="Address Line 1"
            />
          </div>
          
          <div class="mb-2">
            <label for="address2" class="form-label">Address Line 2</label>
            <input
              id="address2"
              class="form-control"
              formControlName="address2"
              placeholder="Address Line 2"
            />
          </div>
          
          <div class="mb-2">
            <label for="country" class="form-label">Country</label>
            <input
              id="country"
              class="form-control"
              formControlName="country"
              placeholder="Country"
            />
          </div>
          
          <div class="mb-2">
            <label for="city" class="form-label">City</label>
            <input
              id="city"
              class="form-control"
              formControlName="city"
              placeholder="City"
            />
          </div>
          
          <div class="mb-2">
            <label for="state" class="form-label">State</label>
            <input
              id="state"
              class="form-control"
              formControlName="state"
              placeholder="State"
            />
          </div>
          
          <div class="mb-2">
            <label for="postalCode" class="form-label">Postal Code</label>
            <input
              id="postalCode"
              class="form-control"
              formControlName="postalCode"
              placeholder="Postal Code"
            />
          </div>
          
          <div class="mb-2">
            <label for="phone" class="form-label">Phone</label>
            <input
              id="phone"
              class="form-control"
              formControlName="phone"
              placeholder="Phone"
              type="tel"
            />
          </div>
          
          <div class="mb-2">
            <label for="firstName" class="form-label">Contact First Name</label>
            <input
              id="firstName"
              class="form-control"
              formControlName="firstName"
              placeholder="Contact First Name"
            />
          </div>
          
          <div class="mb-2">
            <label for="lastName" class="form-label">Contact Last Name</label>
            <input
              id="lastName"
              class="form-control"
              formControlName="lastName"
              placeholder="Contact Last Name"
            />
          </div>
          
          <div class="mb-2">
            <label for="pointOfContactDetails" class="form-label">Point of Contact Details</label>
            <textarea
              id="pointOfContactDetails"
              class="form-control"
              formControlName="pointOfContactDetails"
              placeholder="Point of Contact Details"
              rows="3"
            ></textarea>
          </div>
          
          <div class="form-check mb-2">
            <input
              type="checkbox"
              class="form-check-input"
              id="active"
              formControlName="active"
            />
            <label class="form-check-label" for="active">Active</label>
          </div>
          </div>
          <div class="d-flex gap-2 mt-3">
            <button
              type="submit"
              class="btn btn-gradient flex-fill py-3"
              [disabled]="editForm.invalid || !editForm.dirty || isLoading"
            >
              <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
              {{ isLoading ? 'Updating...' : 'Save Changes' }}
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary flex-fill py-3"
              (click)="onCancel()"
              [disabled]="isLoading"
            >
              Go Back
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>